






































import { ITitleBtn } from "@/types";
import { getVersion, usersInfo } from "@/api/users";
import { TitleBtnEventEnum } from "@/constants";
import { UserModule } from "@/store/modules/user";
import { MessageBox } from "element-ui";
import { Component, Vue } from "vue-property-decorator";
import TitleBar from "../common/title-bar.vue";
import { userGroupFilter } from "@/filters";

@Component({
  name: "UserManage",
  components: {
    TitleBar,
  },
  filters: {
    arrayToString: (arr: string) => {
      // eslint-disable-next-line no-eval
      return eval(arr).join("、");
    },
  },
  methods: {
    userGroupFilter: userGroupFilter,
  },
})
export default class extends Vue {
  // 顶部按钮组
  private btnGroup: ITitleBtn[] = [
    {
      text: "buttons.back",
      type: "default",
      event: TitleBtnEventEnum.BACK,
    },
    {
      text: "admin.createANewUser",
      type: "primary",
      event: TitleBtnEventEnum.CREATE,
    },
  ];

  private loading = false;

  private user = UserModule.roles;

  private userList = [];

  private tableHeight = 300;

  private dialogVisible = false;

  /**
   * 更新密码form
   */
  private passwdForm = {
    oldPwd: "",
    newPwd: "",
    npwd: "",
  };

  created() {
    this.getUsersInfo();
    window.addEventListener("resize", this.onTableHeightChange);
  }

  mounted() {
    this.$nextTick(this.onTableHeightChange);
  }

  destroyed() {
    window.removeEventListener("resize", this.onTableHeightChange);
  }

  /**
   * 表格高度调整
   */
  private onTableHeightChange() {
    this.tableHeight = (
      this.$refs["table-container"] as HTMLElement
    ).offsetHeight;
  }

  private closeDialog() {
    this.dialogVisible = false;
    this.passwdForm = {} as any;
  }

  /**
   * 获取用户列表
   */
  private async getUsersInfo() {
    this.loading = true;
    try {
      const { data } = await getVersion();
      debugger;
      this.userList = data.data;
    } catch (error) {
      this.$message.error(this.$t("admin.requestListExceptions").toString());
    } finally {
      this.loading = false;
    }
  }
}
